import { composeHandlers } from 'bold-ui/lib/util/react'
import { useAlert } from 'components/alert'
import { Form, FormProps, PecFormApi, resetAllFieldStates } from 'components/form'
import { FormState } from 'final-form'
import { useCompartilharVideochamadaMutation } from 'graphql/hooks.generated'
import { useAnalytics } from 'hooks/analytics/useAnalytics'
import { useMemo } from 'react'

import {
  AlertVideochamadaType,
  compartilharChamadaAlertRecord,
  CompartilharVideochamadaAlertData,
} from './model-compartilharVideochamada'
import { validateCompartilharVideochamada } from './validator-compartilharVideochamada'

export interface CompartilharVideochamadaModel {
  emailDestinatario: string
}

interface CompartilharVideochamadaFormProps
  extends Omit<Partial<FormProps<CompartilharVideochamadaModel>>, 'onSubmit'> {
  videochamadaUuid: string
  emailDestinatario: string
  suppressAlertonSuccess?: boolean
  suppressAlertonFailed?: boolean
  resetFormAndFieldStates?: boolean
  onAlert?(alert: CompartilharVideochamadaAlertData): void
}

//TODO (RNG): Implementar teste (#14543)
export function CompartilharVideochamadaForm(props: CompartilharVideochamadaFormProps) {
  const alert = useAlert()

  const {
    videochamadaUuid,
    emailDestinatario,
    suppressAlertonSuccess,
    suppressAlertonFailed,
    resetFormAndFieldStates,
    onAlert = ({ type, message }) => alert(type, message),
    onSubmitSucceeded,
    onSubmitFailed,
    ...rest
  } = props
  const { analytics } = useAnalytics()

  const handleSubmitSuccess = () => {
    analytics.logEvent('TELE_videochamadas_envio_email')
    !suppressAlertonSuccess &&
      onAlert(compartilharChamadaAlertRecord[AlertVideochamadaType.ENVIO_EMAIL_PROFISSIONAL_SUCESSO])
  }

  const handleSubmitFailed = (formState: FormState<CompartilharVideochamadaModel>) => {
    if (formState.hasSubmitErrors) {
      analytics.logEvent('ERR_TELE_videochamadas_envio_email')
      !suppressAlertonFailed &&
        onAlert(compartilharChamadaAlertRecord[AlertVideochamadaType.ENVIO_EMAIL_PROFISSIONAL_ERRO])
    }
  }

  const [compartilharVideochamada] = useCompartilharVideochamadaMutation()

  const handleSubmit = (
    { emailDestinatario }: CompartilharVideochamadaModel,
    form: PecFormApi<CompartilharVideochamadaModel>
  ) =>
    compartilharVideochamada({
      variables: {
        input: {
          videochamadaUuid,
          emailDestinatario,
        },
      },
    }).then(() => {
      if (resetFormAndFieldStates) {
        setTimeout(() => {
          resetAllFieldStates(form)
          form.reset(toEmptyFieldValues(form.getRegisteredFields()))
        }, 0)
      }
    })

  const initialValues = useMemo(() => ({ emailDestinatario }), [emailDestinatario])

  return (
    <Form<CompartilharVideochamadaModel>
      initialValues={initialValues}
      validate={validateCompartilharVideochamada}
      onSubmit={handleSubmit}
      onSubmitSucceeded={composeHandlers(handleSubmitSuccess, onSubmitSucceeded)}
      onSubmitFailed={composeHandlers(handleSubmitFailed, onSubmitFailed)}
      {...rest}
    />
  )
}

const toEmptyFieldValues = (fields: string[]): Record<string, string> =>
  Object.fromEntries(fields.map((field) => [field, '']))
